import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, IconButton } from '@material-ui/core';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';

const useStyles = makeStyles(theme => ({
  heart: {
    fill: "#DE5252",
    color: "#DE5252"
  }
}));

const BookmarkButton = ({ active, onClick, className, style }) => {
  const classes = useStyles();
  return (
    <IconButton className={className} style={style || { padding: 3 }} onClick={onClick}>{active ? <FavoriteIcon className={classes.heart} /> : <FavoriteBorderIcon className={classes.heart} />}</IconButton>
  );
};

BookmarkButton.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.any,
  style: PropTypes.any,
};


export default BookmarkButton;
